(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["atlas-energy-offer-hero"] && !Shopify.designMode) return;
  try {
    
  function initAtlasEnergyHero(root = document) {
    const hero = root.querySelector('.atlas-energy-offer-hero');
    if (!hero || hero.dataset.energyHeroReady === 'true') return;
    hero.dataset.energyHeroReady = 'true';

    let landingLocked = true;
    const cleanUrl = window.location.pathname + window.location.search;
    const currentState = typeof history.state === 'object' && history.state !== null ? history.state : {};

    try {
      history.scrollRestoration = 'manual';
      history.replaceState({ ...currentState, scrollTop: 0 }, '', cleanUrl);
    } catch (_) {
    }

    const resetLandingPosition = () => {
      if (!landingLocked) return;
      const pageWrapper = document.querySelector('.page-wrapper');
      if (pageWrapper) pageWrapper.scrollTo({ top: 0, left: 0, behavior: 'instant' });
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    };

    const releaseLanding = () => {
      landingLocked = false;
    };

    resetLandingPosition();
    requestAnimationFrame(() => requestAnimationFrame(resetLandingPosition));
    window.addEventListener('pageshow', resetLandingPosition);
    window.addEventListener('load', resetLandingPosition, { once: true });
    window.addEventListener('pointerdown', releaseLanding, { once: true, passive: true });
    window.addEventListener('touchstart', releaseLanding, { once: true, passive: true });
    window.addEventListener('wheel', releaseLanding, { once: true, passive: true });
    window.addEventListener('keydown', releaseLanding, { once: true });

    document.querySelectorAll('.atlas-energy-offer-hero__cta, .atlas-listicle-sticky-cta__button').forEach((button) => {
      button.addEventListener('click', (event) => {
        if (button.getAttribute('href') !== '#atlas-product-offer') return;
        const offer = document.querySelector('#atlas-product-offer');
        if (!offer) return;
        event.preventDefault();
        releaseLanding();
        try {
          history.replaceState(history.state, '', cleanUrl);
        } catch (_) {
        }
        offer.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    const sticky = document.querySelector('[data-atlas-energy-sticky]');
    const firstReason = document.querySelector('.atlas-listicle-reason');
    const productOffer = document.querySelector('#atlas-product-offer');
    if (sticky) {
      const updateStickyVisibility = () => {
        const hasPassedFirstReason = !firstReason || firstReason.getBoundingClientRect().bottom <= window.innerHeight;
        const productRect = productOffer ? productOffer.getBoundingClientRect() : null;
        const productIsVisible = productRect && productRect.top < window.innerHeight && productRect.bottom > 0;

        sticky.dataset.visible = hasPassedFirstReason && !productIsVisible ? 'true' : 'false';
      };

      updateStickyVisibility();
      window.addEventListener('scroll', updateStickyVisibility, { passive: true });
      window.addEventListener('resize', updateStickyVisibility, { passive: true });
    }
  }

  function initAtlasEnergyCountdown(root = document) {
    root.querySelectorAll('[data-atlas-energy-countdown]').forEach((timer) => {
      if (timer.dataset.countdownReady === 'true') return;
      timer.dataset.countdownReady = 'true';

      const duration = Math.max(1, Number(timer.dataset.minutes) || 30) * 60 * 1000;
      const endTime = Date.now() + duration;
      const hours = timer.querySelector('[data-hours]');
      const minutes = timer.querySelector('[data-minutes]');
      const seconds = timer.querySelector('[data-seconds]');

      const render = () => {
        const remaining = Math.max(0, endTime - Date.now());
        const totalSeconds = Math.floor(remaining / 1000);
        if (hours) hours.textContent = String(Math.floor(totalSeconds / 3600)).padStart(2, '0');
        if (minutes) minutes.textContent = String(Math.floor(totalSeconds % 3600 / 60)).padStart(2, '0');
        if (seconds) seconds.textContent = String(totalSeconds % 60).padStart(2, '0');
        if (remaining === 0) clearInterval(interval);
      };

      render();
      const interval = setInterval(render, 1000);
    });
  }

  initAtlasEnergyHero();
  initAtlasEnergyCountdown();
  document.addEventListener('shopify:section:load', (event) => {
    initAtlasEnergyHero(event.target);
    initAtlasEnergyCountdown(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atlas-header"] && !Shopify.designMode) return;
  try {
    
  if (!window.atlasHeaderMenuReady) {
    window.atlasHeaderMenuReady = true;

    document.addEventListener('click', (event) => {
      document.querySelectorAll('[data-atlas-menu][open]').forEach((menu) => {
        if (!menu.contains(event.target)) menu.removeAttribute('open');
      });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;

      document.querySelectorAll('[data-atlas-menu][open]').forEach((menu) => {
        menu.removeAttribute('open');
        menu.querySelector('summary')?.focus();
      });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atlas-listicle-hero"] && !Shopify.designMode) return;
  try {
    
  function initAtlasListicleLanding(root = document) {
    const hero = root.querySelector('.atlas-listicle-hero');
    if (!hero || hero.dataset.landingReady === 'true') return;
    hero.dataset.landingReady = 'true';

    let landingLocked = true;
    const cleanUrl = window.location.pathname + window.location.search;
    const currentState = typeof history.state === 'object' && history.state !== null ? history.state : {};

    try {
      history.scrollRestoration = 'manual';
      history.replaceState({ ...currentState, scrollTop: 0 }, '', cleanUrl);
    } catch (_) {
    }

    const resetLandingPosition = () => {
      if (!landingLocked) return;
      const pageWrapper = document.querySelector('.page-wrapper');
      if (pageWrapper) pageWrapper.scrollTo({ top: 0, left: 0, behavior: 'instant' });
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    };

    const resetAfterLayout = () => {
      resetLandingPosition();
      requestAnimationFrame(() => requestAnimationFrame(resetLandingPosition));
    };

    const releaseLanding = () => {
      landingLocked = false;
    };

    resetAfterLayout();
    window.addEventListener('pageshow', resetAfterLayout);
    window.addEventListener('load', resetAfterLayout, { once: true });
    window.addEventListener('pointerdown', releaseLanding, { once: true, passive: true });
    window.addEventListener('touchstart', releaseLanding, { once: true, passive: true });
    window.addEventListener('wheel', releaseLanding, { once: true, passive: true });
    window.addEventListener('keydown', releaseLanding, { once: true });

    document.querySelectorAll('.atlas-listicle-sticky-cta__button').forEach((button) => {
      button.addEventListener('click', (event) => {
        const href = button.getAttribute('href');
        if (href !== '#atlas-product-offer') return;
        const offer = document.querySelector('#atlas-product-offer');
        if (!offer) return;

        event.preventDefault();
        releaseLanding();
        try {
          history.replaceState(history.state, '', cleanUrl);
        } catch (_) {
        }
        offer.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  function initAtlasListicleCountdown(root = document) {
    root.querySelectorAll('[data-atlas-countdown]').forEach((timer) => {
      if (timer.dataset.countdownReady === 'true') return;
      timer.dataset.countdownReady = 'true';

      const duration = Math.max(1, Number(timer.dataset.minutes) || 15) * 60 * 1000;
      const endTime = Date.now() + duration;
      const hours = timer.querySelector('[data-hours]');
      const minutes = timer.querySelector('[data-minutes]');
      const seconds = timer.querySelector('[data-seconds]');

      const render = () => {
        const remaining = Math.max(0, endTime - Date.now());
        const totalSeconds = Math.floor(remaining / 1000);
        if (hours) hours.textContent = String(Math.floor(totalSeconds / 3600)).padStart(2, '0');
        if (minutes) minutes.textContent = String(Math.floor(totalSeconds % 3600 / 60)).padStart(2, '0');
        if (seconds) seconds.textContent = String(totalSeconds % 60).padStart(2, '0');
        if (remaining === 0) clearInterval(interval);
      };

      render();
      const interval = setInterval(render, 1000);
    });
  }

  initAtlasListicleLanding();
  initAtlasListicleCountdown();
  document.addEventListener('shopify:section:load', (event) => {
    initAtlasListicleLanding(event.target);
    initAtlasListicleCountdown(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
